namespace Matrix.Data {
    export interface JpmSecClassOverrideForm {
        SecurityId: FormatViewLookupEditor;
        SecTypeCode: Serenity.StringEditor;
        Industry: Serenity.StringEditor;
        DaysToMaturity: Serenity.StringEditor;
        MaturityBand: Serenity.StringEditor;
        CountryOfExposure: Serenity.StringEditor;
        CurrencyOfExposure: Serenity.StringEditor;
        EmergingMarket: Serenity.StringEditor;
        AaSector: Serenity.StringEditor;
        CounterpartyOrIssuer: Serenity.StringEditor;
        CountryOfIssue: Serenity.StringEditor;
    }

    export class JpmSecClassOverrideForm extends Serenity.PrefixedContext {
        static formKey = 'Data.JpmSecClassOverride';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JpmSecClassOverrideForm.init)  {
                JpmSecClassOverrideForm.init = true;

                var s = Serenity;
                var w0 = FormatViewLookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(JpmSecClassOverrideForm, [
                    'SecurityId', w0,
                    'SecTypeCode', w1,
                    'Industry', w1,
                    'DaysToMaturity', w1,
                    'MaturityBand', w1,
                    'CountryOfExposure', w1,
                    'CurrencyOfExposure', w1,
                    'EmergingMarket', w1,
                    'AaSector', w1,
                    'CounterpartyOrIssuer', w1,
                    'CountryOfIssue', w1
                ]);
            }
        }
    }
}
